module.exports = __webpack_public_path__ + "static/media/information-icon.6c57ac89.svg";